import { formatDate } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TramiteEmvs } from './tramite-emvs';
@Injectable({
  providedIn: 'root'
})
export class ListadoTramitesEmvsService {

  private API_URL: string = environment.API_URL;
  constructor(private http: HttpClient, @Inject(LOCALE_ID) public locale: string) { }

  tramite?: TramiteEmvs;
  tramiteCustom?: any;

  getTramitesByuserId(
  id: number,
  cargaTotal: boolean,
  fechaInicio: any,
  fechaFin: any,
  nif: string,
  nombreProc: string,
  estadoTramite: string,
  pasoTramite: string
) {
  let params = new HttpParams()
    .set('fechaInicio', this.formatDateWithoutHour(fechaInicio))
    .set('fechaFin', this.formatDateWithoutHour(fechaFin))
    .set('nif', nif || '')
    .set('nombreProc', nombreProc || '')
    .set('estadoTramite', estadoTramite || '')
    .set('pasoTramite', pasoTramite || '');

  const endpoint = cargaTotal
    ? `${this.API_URL}/tramite_emvs/all/${id}`
    : `${this.API_URL}/tramite_emvs/${id}`;

  return this.http.get<TramiteEmvs[]>(endpoint, { params });
}
  formatDateWithoutHour(date: any): string {
    if (!date) return '';
    try {
      return formatDate(date, 'dd/MM/yyyy', this.locale);
    } catch {
      return '';
    }
  }
  getTramitesForCSV() {
    return this.http.get<any[]>(`${this.API_URL}/tramite_emvs/getForCSV`);
  }

  downloadJustificanteB64(id: number): Observable<any> {

    let API_URL = `${this.API_URL}/nextcloud/downloadB64/${id}`;
    return this.http.get(API_URL);
  }

  downloadAdjuntosZip(idTramite: number): Observable<any> {
    return this.http.get(`${this.API_URL}/tramite_emvs/adjuntos/${idTramite}`);
  }

  downloadB64(id_documento) {
    const url = `${this.API_URL}/nextcloud/downloadB64/` + id_documento;
    return this.http
      .get<any>(url);
  }

  updateJustificanteB64(form: object): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_emvs/updateFirma`;
    return this.http.post(API_URL, form);
  }

  deleteTramite(tramite: TramiteEmvs) {

    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_emvs/deleteTramite`, {
      body: { id: tramite }
    });
  }

  deleteTramiteForm(tramite: TramiteEmvs) {

    return this.http.delete<TramiteEmvs>(`${this.API_URL}/tramite_emvs/deleteTramite`, {
      body: { id: tramite.id }
    });
  }
  getTramiteById(id: number) {
    return this.http.get<TramiteEmvs>(`${this.API_URL}/tramite_emvs/get/${id}`);
  }

}
